import React, { Fragment, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  notifyTopRight,
  notifyError,
} from "../../toast/SetToast";
import Toast from "../../toast/SetToast";
import { useFirestore } from "../../../../hook/useFirestore";
import { ApproverForm } from "./ApproverForm";
import { db } from "../../../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const ApproverRegister = (props) => {
  const { addDocument } = useFirestore("approvers");
  const inputRef = useRef({
    name: "",
    email: "",
    uid: "",
    status: "",
  });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = inputRef.current.email;
    if (!email) {
      notifyError("Please enter an email address");
      return;
    }

    // Validate email exists in admins collection
    const adminsQuery = query(
      collection(db, "admins"),
      where("email", "==", email)
    );
    const adminsSnapshot = await getDocs(adminsQuery);

    if (adminsSnapshot.empty) {
      notifyError("Email not found in admins. Please use a valid admin email.");
      return;
    }

    const formData = {
      name: inputRef.current.name,
      email: inputRef.current.email,
      uid: inputRef.current.uid,
      status: inputRef.current.status || "Available",
    };

    addDocument(formData)
      .then(() => {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        notifyError("บันทึกข้อมูลผิดพลาด ", err);
      });

    props.hide();
  };

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Register Approver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ApproverForm onChange={handleChange} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default ApproverRegister;
